import React, { useCallback, useState } from 'react'
import { AppTitlePage } from '../../components/AppTitlePage'
import { useTranslation } from 'react-i18next'
import { AppTabsBlock } from 'shared/ui/AppTabsBlock'
import { MainTab } from './components/MainTab'
import { AiTab } from './components/AiTab'
import { useGetCurrentUserQuery } from 'core/api/UserApi'
import { Role } from 'core/api/dto/UserDto'

export enum DetailTab {
  'main' = 'main',
  'info' = 'info',
}

export const OptionsPage = () => {
  const { t } = useTranslation()
  const { data: currentUser } = useGetCurrentUserQuery()
  const isAdministrator =
    currentUser?.userRoles.roleType.includes(Role.ADMINISTRATOR) ?? false

  const [activeTab, setActiveTab] = useState<DetailTab>(DetailTab.main)
  const setActiveTabHandler = useCallback(
    (value: DetailTab) => setActiveTab(value),
    [],
  )

  const tabs = [{ name: t('Общие'), value: DetailTab.main }]
  if (isAdministrator) {
    tabs.push({ name: t('AI'), value: DetailTab.info })
  }

  return (
    <React.Fragment>
      <div className="width-for-page-wrapper">
        <AppTitlePage title="Настройки" />
        <div className="option-page-card mt-20">
          <AppTabsBlock<DetailTab>
            tabs={tabs}
            activeTab={activeTab}
            setActiveTab={setActiveTabHandler}
            className="width-100 top-20"
            underBlock={null}
          >
            {activeTab === DetailTab.main && <MainTab />}
            {activeTab === DetailTab.info && isAdministrator && <AiTab />}
          </AppTabsBlock>
        </div>
      </div>
    </React.Fragment>
  )
}
